import { h } from "preact";
import { useState, useEffect, } from "preact/hooks";

import {
	Box,

	Popover,
	Tooltip,
	Typography,
} from "@mui/material";

import InfoIcon from '@mui/icons-material/Info';
import { ToggleButton, ToggleButtonGroup } from "@mui/lab";
import WarningIcon from '@mui/icons-material/Warning';

export default function FormMultiToggle({ upperState, id, handleChange, helper, options, exclusive }) {

	const handleExpos = (event, newFormats) => {
		console.log(newFormats);
		//setState(newFormats);
		handleChange({ target: { name: id, value: newFormats } });
	};

	const [anchorEl, setAnchorEl] = useState(null);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};
	const value = upperState[id];
	const mnd = upperState[id + "_mnd"];
	const open = Boolean(anchorEl);
	const label = upperState[id + "_lbl"];
	return (
		<Box display="flex" justifyContent="space-between" alignItems="center" >
			<Box display="flex" justifyContent="flex-start" alignItems="center">
				<Box p={1}>
					<InfoIcon aria-haspopup="true"
						aria-owns={open ? 'mouse-over-popover' : undefined}
						onMouseEnter={handlePopoverOpen}
						onMouseLeave={handlePopoverClose}
						style="margin-top: 6px;"
						color={helper ? "" : "disabled"}
					/>
					<Popover
						id="mouse-over-popover"
						sx={{
							pointerEvents: 'none',
						}}
						open={open}
						anchorEl={anchorEl}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'left',
						}}
						onClose={handlePopoverClose}
						disableRestoreFocus
					>
						<Typography sx={{ p: 1 }}>{helper ? helper : <em>Pas encore d'aide, déso</em>}</Typography>
					</Popover>
				</Box>
				<Box p={1}>
					<Typography variant="body1">{label} {mnd ? "*" : null}</Typography>
				</Box>
				<Box p={1}>
					{upperState[id + "_fld"] ? <Tooltip title="Ce champ est obligatoire"><WarningIcon color="primary" /></Tooltip> : ""}
				</Box>
			</Box>

			<Box >

				<ToggleButtonGroup
					value={value}
					exclusive={exclusive}
					onChange={handleExpos}
					aria-label="text formatting"
					size="small"
					color="primary"
				>
					{options.map((opt) => {
						return <ToggleButton value={opt.o} aria-label={opt.l}>
							{opt.l}
						</ToggleButton>
					})}

					{/* <ToggleButton value="E" aria-label="EST">
						EST
					</ToggleButton>
					<ToggleButton value="O" aria-label="OUEST">
						OUEST
					</ToggleButton>
					<ToggleButton value="N" aria-label="NORD">
						NORD
					</ToggleButton> */}
				</ToggleButtonGroup>
			</Box>

		</Box>
	);
}
